import { BadgeV3, Spinner } from '@cimplico/components';
import { useFirmContext } from '../../../providers/FirmProvider';
import { useWorkpaperContext } from '../../../providers/WorkpaperProvider';
import { useWorkpaperProcedure } from '../../../queries/use-workpaper-procedure';
import NotesList from '../notes/NotesList';
import WorkpaperProcedureDetails from './WorkpaperProcedureDetails';
import ErrorSplashScreen from '../../../pages/ErrorSplashScreen';

export default function WorkpaperProcedureDetailsContainer({ focusedProcedureId }: { focusedProcedureId: string }): JSX.Element {
    const { shortId } = useFirmContext();
    const { id: workpaperId } = useWorkpaperContext();

    const workpaperProcedureQuery = useWorkpaperProcedure(workpaperId, focusedProcedureId);

    if (workpaperProcedureQuery.isLoading) {
        return (
            <div className="absolute w-full h-[var(--remaining-screen-height)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner size="sm" />
                </div>
            </div>
        );
    }

    if (workpaperProcedureQuery.isError || !workpaperProcedureQuery.isSuccess) {
        if (workpaperProcedureQuery.error?.response?.status === 404) {
            return (
                <ErrorSplashScreen
                    errorCode={404}
                    title="Procedure not found."
                    redirectTitle="Go back"
                    redirectUrl={`/${shortId}/workpapers/${workpaperId}/procedures`}
                    leftArrow={true}
                    smallScreen
                />
            );
        }
        return <ErrorSplashScreen title="An error has occurred." smallScreen />;
    }

    const { workpaperProcedure } = workpaperProcedureQuery.data;

    return (
        <div className="flex flex-col gap-4 h-full">
            <WorkpaperProcedureDetails workpaperProcedure={workpaperProcedure} />
            <div className="border-t p-4 pr-8 -ml-4 -mr-8 flex flex-col gap-4 h-full">
                <div className="flex gap-1">
                    <p className="font-medium text-gray-800">Notes</p>
                    <BadgeV3 label={workpaperProcedure.notes.length.toString()} rounded />
                </div>
                <NotesList procedureId={workpaperProcedure.id} notes={workpaperProcedure.notes} />
            </div>
        </div>
    );
}
